export { CgcPipe } from './cgc.pipe';
export { FirstLetterPipe } from './first-letter.pipe';
export { DatePipe } from './date.pipe';
export { NumberPipe } from './number.pipe';
export { PhonePipe } from './phone.pipe';
export { PlatePipe } from './plate.pipe';
